import { Type } from '@sinclair/typebox';
import { addCustomStickerLineItemCommandSchema, addStickerShopLineItemCommandSchema, addStickerPackLineItemCommandSchema, addGiftCardLineItemCommandSchema, removeLineItemCommandSchema, updateLineItemCommandSchema, duplicateCustomStickerLineItemCommandSchema, addLinesFromOrderCommandSchema, createCartFromManualOrderCommandSchema, } from "./lineItem.mjs";
import { selectShippingMethodCommandSchema } from "./shipping.mjs";
import { selectPaymentMethodCommandSchema, addCodeCommandSchema, removeCodeCommandSchema } from "./payment.mjs";
import { setAddressCommandSchema, setCompanyNameCommandSchema, setEmailCommandSchema, setIsCompanyCommandSchema, setPhoneNumberCommandSchema, setBillingAddressCommandSchema, setUseBillingAddressCommandSchema, setReferenceCommandSchema, setVatNumberCommandSchema, setCommentCommandSchema, setShoutCommandSchema, } from "./customer.mjs";
import { recoverCartCommandSchema } from "./cart.mjs";
export * from "./lineItem.mjs";
export * from "./payment.mjs";
export * from "./shipping.mjs";
export * from "./customer.mjs";
export * from "./cart.mjs";
export const cartCommandsSchema = Type.Union([
    addCustomStickerLineItemCommandSchema,
    addStickerShopLineItemCommandSchema,
    addStickerPackLineItemCommandSchema,
    addGiftCardLineItemCommandSchema,
    duplicateCustomStickerLineItemCommandSchema,
    removeLineItemCommandSchema,
    addLinesFromOrderCommandSchema,
    createCartFromManualOrderCommandSchema,
    updateLineItemCommandSchema,
    selectShippingMethodCommandSchema,
    selectPaymentMethodCommandSchema,
    addCodeCommandSchema,
    removeCodeCommandSchema,
    setEmailCommandSchema,
    setPhoneNumberCommandSchema,
    setCompanyNameCommandSchema,
    setIsCompanyCommandSchema,
    setVatNumberCommandSchema,
    setAddressCommandSchema,
    setBillingAddressCommandSchema,
    setUseBillingAddressCommandSchema,
    setReferenceCommandSchema,
    setCommentCommandSchema,
    recoverCartCommandSchema,
    setShoutCommandSchema,
]);
//# sourceMappingURL=index.js.map